import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import _cx from 'classnames/bind';
import Button from '../button';
import Icon from '../icon';
import Alert, { alertSlotsPropType } from '../alert';
import cls from './index.scss';
const cx = _cx.bind(cls);
class FixedMessage extends Component {
    static propTypes = {
        role: PropTypes.oneOf([
            'notification',
            'information',
            'success',
            'warning',
            'error',
            'none',
        ]),
        showIcon: PropTypes.bool,
        isVisible: PropTypes.bool,
        isCloseable: PropTypes.bool,
        onClose: PropTypes.func,
        className: PropTypes.string,
        elmId: PropTypes.string,
        children: PropTypes.node,
        style: PropTypes.object,
        slots: alertSlotsPropType,
        useDeprecatedVersion: PropTypes.bool,
        notification: PropTypes.bool,
        inlineButton: PropTypes.bool,
    };
    static defaultProps = {
        role: 'information',
        showIcon: false,
        isVisible: true,
        isCloseable: false,
        elmId: 'fixed_message_alert',
        onClose: () => { },
        slots: null,
        useDeprecatedVersion: false,
        notification: false,
        inlineButton: false,
    };
    getMessageBody(children) {
        const messageBody = [];
        Children.map(children, (ch, i) => {
            if (ch &&
                !((ch.type && ch.type.name === 'Button') || ch.type === Button)) {
                messageBody.push(ch);
            }
        });
        return _jsx("div", { className: cx('message-body'), children: messageBody });
    }
    getButtons(children) {
        let button = null;
        Children.map(children, (ch, i) => {
            if (ch &&
                ((ch.type && ch.type.name === 'Button') || ch.type === Button)) {
                if (button !== null) {
                    return new Error('Only one button child may be present in a Fixed Message');
                }
                button = React.cloneElement(ch, {
                    className: cls.button,
                });
            }
        });
        return _jsx("div", { className: cx('message-action'), children: button });
    }
    render() {
        const { role, showIcon, isVisible, isCloseable, onClose, className, children, elmId, slots, useDeprecatedVersion, notification, inlineButton, ...rest } = this.props;
        const roleIcon = {
            notification: { icon: 'warning circle', color: 'white' },
            information: { icon: 'info', color: 'info' },
            success: { icon: 'check', color: 'success' },
            warning: { icon: 'warning circle', color: 'caution' },
            error: { icon: 'warning circle', color: 'error' },
        }[role];
        if (useDeprecatedVersion === false) {
            const roleMap = {
                information: 'info',
                warning: 'caution',
                error: 'error',
                success: 'success',
                none: '',
            };
            return (_jsx(Alert, { role: roleMap[role], showIcon: showIcon, className: className, content: children, slots: slots, hidden: !isVisible, onDismiss: isCloseable ? onClose : null, style: rest.style, elmId: elmId }));
        }
        return (_jsxs("div", { className: _cx(cls.root, notification && cls.notification, cls[`role-${role}`], className, inlineButton && cls['inline-btn-container']), style: { display: isVisible ? undefined : 'none' }, "data-elm-id": elmId, ...rest, children: [_jsxs("div", { className: cx('message-content'), children: [showIcon && (_jsx("div", { className: cx('message-icon'), children: _jsx(Icon, { size: 'large', name: roleIcon.icon, color: roleIcon.color }) })), this.getMessageBody(children)] }), this.getButtons(children), isCloseable && (_jsx("div", { className: cx('close-icon', 'click-area'), onClick: onClose, children: _jsx(Icon, { size: 'small', name: 'close', color: notification ? 'grayLight' : 'grayMedium' }) }))] }));
    }
}
export default FixedMessage;
//# sourceMappingURL=index.js.map